export const HAS_DISMISSED_NEWSLETTER_SUBSCRIPTION_MODAL_KEY =
  'mnpg-newsletter-subscription-modal-has-been-dismissed'
